module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic-ext36.251d36f.woff2";